import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserIdleStatus } from '@redux/selectors/UserSelector';
import { heartBeat } from '@redux/reducers/application/Authentication';
import useInterval from '@hooks/useInterval';
import usePrevious from '@hooks/usePrevious';

const HEARTBEAT_INTERVAL_DELAY = 1000 * 60 * 5; // 5 minutes

const useHeartBeat = () => {
  const dispatch = useDispatch();
  const authChecked = useSelector(({ authentication }) => authentication.authChecked);
  const isLoadingAuth = useSelector(({ authentication }) => authentication.isLoadingAuth);
  const isAuthenticated = useSelector(({ authentication }) => authentication.isAuthenticated);
  const isAuthCloseToExpiry = useSelector(({ authentication }) => authentication.isAuthCloseToExpiry);
  const isIdle = useSelector(getUserIdleStatus);
  const prevIsIdle = usePrevious(isIdle);
  const heartBeatEnabled = !isIdle && authChecked && isAuthenticated && !isLoadingAuth && !isAuthCloseToExpiry;

  useInterval(() => dispatch(heartBeat()), heartBeatEnabled ? HEARTBEAT_INTERVAL_DELAY : null);

  useEffect(() => {
    dispatch(heartBeat());
  }, []);

  useEffect(() => {
    if (prevIsIdle && heartBeatEnabled) {
      dispatch(heartBeat());
    }
  }, [isIdle, heartBeatEnabled]);
};

export default useHeartBeat;
